import { Box, HStack, Text } from '@chakra-ui/react';
import { CheckCircle, Prohibition } from 'iconoir-react';
import { GuidelineListEditor } from './GuidelineListEditor';

interface DoDontCardProps {
  kind: 'dos' | 'donts';
  title: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

/**
 * "À faire" / "À éviter" card (design 4.11 row 2): a colored header (green
 * check for do's, red prohibition for don'ts) above the list of guidelines,
 * one row per item, which is how the creator reads them in the portal.
 */
export const DoDontCard = ({ kind, title, placeholder, value, onChange }: DoDontCardProps) => {
  const isDos = kind === 'dos';
  const headerColor = isDos ? 'green.600' : 'fg.error';
  const Icon = isDos ? CheckCircle : Prohibition;

  return (
    <Box borderWidth="1px" borderColor="cardBorder" rounded="lg" bg="panelBg" px="14px" py="3">
      <HStack gap="1.5" mb="2" color={headerColor}>
        <Icon width={15} height={15} />
        <Text fontFamily="heading" fontSize="12.5px" fontWeight="semibold">
          {title}
        </Text>
      </HStack>
      <GuidelineListEditor
        kind={kind}
        title={title}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </Box>
  );
};
